// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BankVerification_MainContainer__xPJpj {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: clamp(20px, 5vw, 50px);
  box-sizing: border-box;
  overflow-x: hidden;
}

.BankVerification_MainWrapper__ft\\+\\+V {
  border: 1px solid #ffaeae;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 0 0 15px 3px #817e7e1a;
  width: 90%;
  max-width: 800px;
  height: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}

.BankVerification_topPANDiv__IePNZ {
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #e4e4e4;
  padding: 12px;
}

.BankVerification_topPanText__2Ax11 {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: #363636;
  margin-top: 5px;
}

.BankVerification_topClockDiv__x6gAy {
  display: flex;
  gap: 5px;
  margin-top: 7px;
}

.BankVerification_clockIcon__UZ195 {
  height: 20px;
  width: 20px;
  align-self: center;
}

.BankVerification_clockText__o0chU {
  font-size: 14px;
  color: #817e7e;
}

.BankVerification_panDemoDiv__3uVKi {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 30px;
}

.BankVerification_EnterYourPan__-RuFW {
  font-family: "CircularXXWeb-Medium";
  font-size: 16px;
  color: #040404cc;
}

.BankVerification_panInputDiv__lFBL0 {
  display: flex;
  flex-direction: column;
  padding: 0 clamp(15px, 5vw, 25%);
  margin-top: clamp(30px, 5vh, 50px);
  width: 100%;
  box-sizing: border-box;
}

.BankVerification_shieldDiv__UNQtN {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  justify-content: center;
  margin-top: 50px;
}

.BankVerification_shieldText__M9D3Q {
  font-size: 14px;
  color: #404040bf;
  margin-left: 5px;
}

.BankVerification_Line__WJKmg {
  border-bottom: 1px solid #e4e4e4;
  margin-top: 50px;
}

.BankVerification_verifyButton__mBlu4 {
  background-image: linear-gradient(to right, #f73439, #f8777b) !important;
  font-size: clamp(14px, 1.5vw, 16px);
  font-weight: 500;
  font-stretch: normal;
  color: #fff;
  border-radius: 10px !important;
  border: none;
  cursor: pointer;
  padding: clamp(10px, 1.5vw, 14px) clamp(24px, 3vw, 34px);
  margin: clamp(15px, 2vh, 20px) auto;
  width: fit-content;
  min-width: 140px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(247, 52, 57, 0.2);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.BankVerification_verifyButton__mBlu4:active {
  box-shadow: 0 3px 10px rgba(247, 52, 57, 0.2);
}

.BankVerification_verifyButton__mBlu4:disabled {
  background-image: linear-gradient(to right, #cccccc, #dddddd) !important;
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.8;
}

.BankVerification_verifyButton__mBlu4.BankVerification_loading__GJCBH {
  pointer-events: none;
}

.BankVerification_loadingDots__2ylHq {
  display: inline-flex;
  margin-left: 8px;
  align-items: center;
}

.BankVerification_loadingDots__2ylHq span {
  width: 4px;
  height: 4px;
  margin: 0 2px;
  background-color: #fff;
  border-radius: 50%;
  display: inline-block;
  animation: BankVerification_loadingDots__2ylHq 1.4s infinite ease-in-out both;
}

.BankVerification_loadingDots__2ylHq span:nth-child(1) {
  animation-delay: 0s;
}

.BankVerification_loadingDots__2ylHq span:nth-child(2) {
  animation-delay: 0.2s;
}

.BankVerification_loadingDots__2ylHq span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes BankVerification_loadingDots__2ylHq {
  0%,
  80%,
  100% {
    transform: scale(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.BankVerification_PaymentDiv__rlRlj {
  display: flex;
  width: clamp(85%, 75%, 95%);
  margin: 0 auto;
  margin-top: clamp(30px, 5vh, 50px);
  justify-content: space-between;
  border: 1px solid #e8e8e8;
  border-radius: 16px;
  padding: clamp(18px, 2.5vw, 26px);
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  background: #fff;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.BankVerification_PaymentDiv__rlRlj:hover {
  border-color: #f73439;
  background: #fff;
  box-shadow: 0 8px 20px rgba(247, 52, 57, 0.1);
  transform: translateY(-2px);
}

.BankVerification_UPI_Container__JHSUu {
  display: flex;
}

@keyframes BankVerification_shine__lrOXM {
  to {
    background-position: -100% 0;
  }
}

.BankVerification_PaymentMode__EjiHa {
  width: 100%;
  flex: 1 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.BankVerification_PaymentHeading__8-0d3 {
  display: flex;
  font-size: clamp(14px, 2vw, 16px);
  margin-top: 0.5px;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  color: #2d2d2d;
  font-weight: 500;
  text-align: left;
}

.BankVerification_UPI_Layer__p-\\+wO {
  margin-left: 5px;
  color: #f73439;
  font-weight: 600;
  max-height: 25px;
}

.BankVerification_PaymentDes__XC8gC {
  font-size: 13px;
  color: #666;
  white-space: break-spaces;
  margin-top: 12px;
  line-height: 1.6;
  letter-spacing: 0.2px;
  width: 250px;
}

.BankVerification_PaymentDesBank__rLXRd {
  margin-left: 10%;
  margin-top: 10px;
}

.BankVerification_customCheckbox__Dh9jK {
  display: flex;
  cursor: pointer;
  transition: all 0.2s ease;
  align-items: flex-start;
}

.BankVerification_customCheckbox__Dh9jK:hover {
  transform: translateY(-1px);
}

.BankVerification_customCheckbox__Dh9jK input {
  display: none;
}

.BankVerification_customCheckbox__Dh9jK .BankVerification_checkmark__U6fPL {
  width: 22px;
  height: 22px;
  border: 2px solid #f73439;
  border-radius: 6px;
  margin-right: 12px;
  position: relative;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(247, 52, 57, 0.1);
}

.BankVerification_customCheckbox__Dh9jK:hover .BankVerification_checkmark__U6fPL {
  box-shadow: 0 4px 8px rgba(247, 52, 57, 0.15);
}

.BankVerification_customCheckbox__Dh9jK input:checked + .BankVerification_checkmark__U6fPL {
  background-color: #f73439;
  animation: BankVerification_checkmark-pop__xBmFe 0.3s ease-out;
}

@keyframes BankVerification_checkmark-pop__xBmFe {
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.BankVerification_customCheckbox__Dh9jK input:checked + .BankVerification_checkmark__U6fPL::after {
  content: "";
  position: absolute;
  left: 6px;
  top: 2px;
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  animation: BankVerification_checkmark-check__FdAnV 0.2s ease-in-out 0.1s both;
}

@keyframes BankVerification_checkmark-check__FdAnV {
  0% {
    height: 0;
    opacity: 0;
  }
  100% {
    height: 12px;
    opacity: 1;
  }
}

.BankVerification_bankInput1__4Ga8C,
.BankVerification_bankInput2__ZudwV {
  border: none;
  border-bottom: 2px solid #fa7a70;
  border-top: none;
  padding: 10px 8px;
  font-size: 15px;
  width: 100%;
  transition: all 0.3s ease;
  background-color: rgba(255, 255, 255, 0.7);
  color: #333;
  margin-bottom: 15px;
  outline: none;
  position: relative;
  z-index: 10;
  cursor: text;
  border-radius: 4px 4px 0 0;
}

.BankVerification_bankInput1__4Ga8C:focus,
.BankVerification_bankInput2__ZudwV:focus {
  border-bottom: 2px solid #f73439;
  box-shadow: 0 4px 6px -4px rgba(247, 52, 57, 0.25);
}

.BankVerification_bankInput1__4Ga8C::placeholder,
.BankVerification_bankInput2__ZudwV::placeholder {
  color: #999;
  font-size: 14px;
}

.BankVerification_upiBottomSheet__dLcfl {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
  transform: translateY(100%);
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  z-index: 1000;
  padding: 24px;
  max-height: 85vh;
  overflow-y: auto;
  backdrop-filter: blur(10px);
}

.BankVerification_upiBottomSheet__dLcfl.BankVerification_show__RTxCj {
  transform: translateY(0);
  animation: BankVerification_slideUpAnimation__hLmJa 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes BankVerification_slideUpAnimation__hLmJa {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.BankVerification_upiBottomSheetOverlay__itxd\\+ {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease;
  z-index: 999;
  backdrop-filter: blur(3px);
}

.BankVerification_upiBottomSheetOverlay__itxd\\+.BankVerification_show__RTxCj {
  opacity: 1;
  visibility: visible;
  animation: BankVerification_fadeInAnimation__pLoCC 0.3s ease forwards;
}

@keyframes BankVerification_fadeInAnimation__pLoCC {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.BankVerification_bottomSheetHeader__3Iehc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  position: sticky;
  top: 0;
  background: #fff;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.BankVerification_bottomSheetTitle__BMiLH {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.BankVerification_closeButton__T8o3h {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: #f5f5f5;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 18px;
  color: #555;
}

.BankVerification_closeButton__T8o3h:hover {
  background: #ebebeb;
  transform: rotate(90deg);
}

.BankVerification_closeButton__T8o3h:active {
  transform: scale(0.92) rotate(90deg);
  background: #e0e0e0;
}

.BankVerification_timerSection__J0qym {
  text-align: center;
  margin-bottom: 16px;
  padding: 12px 0;
}

.BankVerification_timerCircle__2\\+r9\\+ {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  border: 3px solid #f73439;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: bold;
  color: #f73439;
  margin: 0 auto 16px;
  animation: BankVerification_pulse__SGX5c 1.5s ease-in-out infinite;
  box-shadow: 0 6px 20px rgba(247, 52, 57, 0.15);
  background: rgba(255, 255, 255, 0.9);
}

.BankVerification_timerText__4CHZg {
  color: #555;
  font-size: 14px;
  margin-top: 10px;
  line-height: 1.5;
  font-weight: 500;
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.BankVerification_timer__G2TpL {
  margin: 24px 0;
  position: relative;
}

.BankVerification_timerPopup__oXGQw {
  max-width: 360px;
}

.BankVerification_upiAppsGrid__EJRHK {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(55px, 1fr));
  gap: 8px;
  margin-top: 16px;
  padding: 0 4px;
}

@keyframes BankVerification_fadeInUp__BYlqh {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.BankVerification_upiBottomSheet__dLcfl.BankVerification_show__RTxCj .BankVerification_upiAppIcon__UvykF {
  animation: BankVerification_fadeInUp__BYlqh 0.25s ease forwards;
  animation-delay: calc(0.04s * var(--icon-index, 0));
  opacity: 0;
}

.BankVerification_upiAppIcon__UvykF {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 3px;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 5px;
  border-radius: 6px;
  margin: 3px;
  height: 50px;
}

.BankVerification_upiAppIcon__UvykF:active {
  background-color: rgba(247, 52, 57, 0.05);
  transform: scale(0.95);
}

.BankVerification_upiAppIcon__UvykF img {
  width: 24px;
  height: 24px;
  padding: 3px;
  border-radius: 6px;
  background: #f8f8f8;
  transition: all 0.2s ease;
  object-fit: contain;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.BankVerification_upiAppIcon__UvykF:hover {
  transform: translateY(-2px);
}

.BankVerification_upiAppIcon__UvykF:hover img {
  background: #f0f0f0;
}

.BankVerification_upiAppLabel__rUedf {
  font-size: 11px;
  color: #555;
  margin-top: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  font-weight: 500;
  letter-spacing: 0.2px;
}

@keyframes BankVerification_pulse__SGX5c {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(247, 52, 57, 0.4);
  }
  70% {
    transform: scale(1.03);
    box-shadow: 0 0 0 8px rgba(247, 52, 57, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(247, 52, 57, 0);
  }
}

@media (max-width: 768px) {
  .BankVerification_popupContentDesktop__AVtFv {
    display: none;
  }

  .BankVerification_popupContentMobile__LrY3V {
    display: block;
    padding: 15px 10px;
  }

  .BankVerification_timerCircle__2\\+r9\\+ {
    width: 70px;
    height: 70px;
    font-size: 18px;
    border-width: 2px;
    margin-bottom: 12px;
  }

  .BankVerification_upiBottomSheet__dLcfl {
    padding: 20px 16px;
    border-radius: 20px 20px 0 0;
  }

  .BankVerification_bottomSheetHeader__3Iehc {
    margin-bottom: 12px;
    padding-bottom: 10px;
  }

  .BankVerification_bottomSheetTitle__BMiLH {
    font-size: 16px;
    font-weight: 600;
  }

  .BankVerification_closeButton__T8o3h {
    width: 28px;
    height: 28px;
    top: 12px;
    right: 12px;
  }

  .BankVerification_upiAppsGrid__EJRHK {
    grid-template-columns: repeat(auto-fit, minmax(60px, 1fr));
    gap: 12px;
    margin-top: 20px;
  }

  .BankVerification_upiAppIcon__UvykF {
    width: 42px;
    height: 42px;
    padding: 8px;
  }

  .BankVerification_upiAppLabel__rUedf {
    font-size: 12px;
    letter-spacing: 0.1px;
    margin-top: 6px;
  }

  .BankVerification_timerSection__J0qym {
    margin-bottom: 15px;
    padding: 10px 0;
  }

  .BankVerification_timerText__4CHZg {
    font-size: 13px;
    max-width: 90%;
  }

  .BankVerification_upiAppButtons__BJnnH {
    gap: 14px;
    margin: 16px 0;
  }

  .BankVerification_popup__O2fhG {
    padding: 20px 16px;
    max-width: 340px;
  }

  .BankVerification_popupContent__sbIB7 h3 {
    font-size: 18px;
    margin-bottom: 12px;
  }

  .BankVerification_popupContent__sbIB7 h4 {
    font-size: 16px;
    margin: 12px 0;
  }

  .BankVerification_popupContent__sbIB7 p {
    font-size: 13px;
    margin-bottom: 16px;
  }

  .BankVerification_popupContent__sbIB7 button {
    padding: 9px 20px;
    font-size: 14px;
  }
}

@media (min-width: 769px) {
  .BankVerification_popupContentMobile__LrY3V {
    display: none;
  }

  .BankVerification_popupContentDesktop__AVtFv {
    display: block;
  }
}

.BankVerification_BankLabel1__boNp5,
.BankVerification_BankLabel2__wpfdK {
  color: rgb(0 0 0 / 87%);
  font-size: clamp(10px, 1.2vw, 12px);
  margin-bottom: clamp(5px, 1vh, 7px);
  position: relative;
  z-index: 5;
}

.BankVerification_BankLabel1__boNp5 {
  margin-top: clamp(30px, 5vh, 50px);
}
.BankVerification_Bankifsc__gADVp {
  margin-top: 10%;
}

.BankVerification_errorText__-JzQ\\+ {
  color: #f73439;
  font-size: 12px;
  margin-top: -10px;
  margin-bottom: 10px;
  font-weight: 500;
  background-color: rgba(247, 52, 57, 0.05);
  padding: 6px 8px;
  border-radius: 4px;
  position: relative;
  z-index: 10;
}

.BankVerification_popupOverlay__j0iat {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.BankVerification_popup__O2fhG {
  background: white;
  padding: clamp(20px, 3vw, 28px);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  max-width: 420px;
  width: 95%;
  margin: 10px;
  box-sizing: border-box;
  animation: BankVerification_popupFadeIn__Q4u\\+6 0.3s ease-out;
  transform-origin: center;
}

@keyframes BankVerification_popupFadeIn__Q4u\\+6 {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.BankVerification_popupContent__sbIB7 {
  text-align: center;
}

.BankVerification_popupContent__sbIB7 h3 {
  color: #333;
  margin-bottom: 16px;
  font-size: 20px;
  font-weight: 600;
}

.BankVerification_popupContent__sbIB7 h4 {
  color: #f73439;
  margin: 16px 0;
  font-size: 18px;
  font-weight: 600;
}

.BankVerification_popupContent__sbIB7 p {
  color: #555;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.5;
}

.BankVerification_popupContent__sbIB7 button {
  background-image: linear-gradient(to right, #f73439, #f8777b);
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.2s ease;
  box-shadow: 0 4px 10px rgba(247, 52, 57, 0.2);
  margin-top: 8px;
}

.BankVerification_popupContent__sbIB7 button:hover {
  background-image: linear-gradient(to right, #e62d32, #f66b6f);
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(247, 52, 57, 0.25);
}

.BankVerification_popupContent__sbIB7 button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(247, 52, 57, 0.2);
}

.BankVerification_upiImgPopupWrapper__Zr572 {
  display: flex;
  gap: 18px;
  align-items: center;
  width: 100%;
  justify-content: center;
  margin: 20px 0;
}

.BankVerification_upiImgPopup__ybL5s {
  height: 32px;
  transition: all 0.2s ease;
  padding: 8px;
  border-radius: 12px;
  background-color: #f8f8f8;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.BankVerification_upiImgPopup__ybL5s:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background-color: #f0f0f0;
}

.BankVerification_upiAppButtons__BJnnH {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin: 20px 0;
  flex-wrap: wrap;
}

.BankVerification_upiAppIcon__UvykF {
  width: 48px;
  height: 48px;
  padding: 10px;
  border-radius: 12px;
  background-color: #f8f8f8;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  cursor: pointer;
}

.BankVerification_upiAppIcon__UvykF:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background-color: #f0f0f0;
}

.BankVerification_popupContentDesktop__AVtFv {
  text-align: center;
  padding: 5px;
}

.BankVerification_popupContentDesktop__AVtFv img[alt="UPI_QR"] {
  max-width: 200px;
  height: auto;
  margin: 15px auto;
  border-radius: 12px;
  padding: 12px;
  background-color: white;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.BankVerification_popupContentDesktop__AVtFv img[alt="UPI_QR"]:hover {
  transform: scale(1.02);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.BankVerification_popupContentMobile__LrY3V {
  display: none;
}

@media (max-width: 768px) {
  .BankVerification_MainWrapper__ft\\+\\+V {
    width: 95%;
    margin: 10px;
  }

  .BankVerification_PaymentDiv__rlRlj {
    width: 90%;
    padding: 12px;
  }

  .BankVerification_PaymentMode__EjiHa {
    width: 100%;
  }

  .BankVerification_PaymentDes__XC8gC {
    font-size: 11px;
  }

  .BankVerification_topPanText__2Ax11 {
    font-size: clamp(16px, 4vw, 20px);
  }

  .BankVerification_clockText__o0chU {
    font-size: 12px;
  }

  .BankVerification_popupContentDesktop__AVtFv {
    display: none;
  }

  .BankVerification_popupContentMobile__LrY3V {
    display: block;
    padding: 10px;
  }

  .BankVerification_upiImgPopup__ybL5s {
    height: 25px;
  }

  .BankVerification_popup__O2fhG {
    margin: 5px;
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .BankVerification_MainContainer__xPJpj {
    padding: 10px;
  }

  .BankVerification_MainWrapper__ft\\+\\+V {
    width: 100%;
    margin: 0;
    border-radius: 10px;
  }

  .BankVerification_PaymentDiv__rlRlj {
    width: 95%;
    padding: 10px;
    margin-top: 20px;
  }

  .BankVerification_shieldDiv__UNQtN {
    margin-top: 30px;
    padding: 0 10px;
  }

  .BankVerification_shieldText__M9D3Q {
    font-size: 12px;
  }

  .BankVerification_Line__WJKmg {
    margin-top: 30px;
  }
}
/* Popup container */
.BankVerification_popupContent__sbIB7 {
  padding: 22px 24px 24px;
}

/* Title */
.BankVerification_popupTitle__Pz5jQ {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 6px; /* was 8 */
  color: #111;
}

/* Subtitle */
.BankVerification_popupSubText__lMcnE {
  font-size: 14px;
  color: #555;
  margin-bottom: 18px; /* was 16 */
  line-height: 1.45;
}

/* Document box */
.BankVerification_documentBox__cGbGF {
  background: #f6f7f9;
  border-radius: 8px;
  padding: 12px 14px; /* tighter */
  margin-bottom: 20px; /* more separation */
}

.BankVerification_documentTitle__4Sj35 {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 4px; /* tighter */
}

.BankVerification_documentBox__cGbGF ul {
  margin: 0;
  padding-left: 16px; /* tighter indent */
  font-size: 13px;
  color: #444;
}

.BankVerification_documentBox__cGbGF li {
  margin-bottom: 4px;
}

/* Upload field */
.BankVerification_uploadField__3tYWI {
  margin-bottom: 22px; /* more breathing */
}

.BankVerification_uploadLabel__OXV0x {
  display: block;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 6px;
  color: #333;
}

.BankVerification_fileInput__0ern1 {
  width: 100%;
  font-size: 13px;
  padding: 6px 2px;
}

.BankVerification_uploadHint__Zac68 {
  font-size: 12px;
  color: #777;
  margin-top: 6px;
}

/* Buttons */
.BankVerification_popupPrimaryBtn__jKFhF {
  width: 100%;
  height: 44px;
  margin-top: 4px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
}

.BankVerification_popupSecondaryBtn__d\\+v4L {
  background: transparent !important;
  background-image: none !important;

  border: 1px solid #f85e63 !important;
  box-shadow: none !important;

  color: #666 !important;
  font-size: 13px !important;

  width: 100%;
  margin-top: 14px;
  padding: 0;

  cursor: pointer;
}

.BankVerification_fileInput__0ern1 {
  width: 100%;
  font-size: 13px;
}

.BankVerification_uploadHint__Zac68 {
  font-size: 12px !important;
  color: #777;
  margin-top: 4px;
}

.BankVerification_uploadField__3tYWI {
  margin-bottom: 20px;
}

.BankVerification_uploadLabel__OXV0x {
  display: block;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 6px;
  color: #333;
}

.BankVerification_uploadBox__A5u\\+q {
  position: relative;
  border: 2px dashed #cfd4dc;
  border-radius: 12px;
  padding: 28px 16px;
  text-align: center;
  background: #fff;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background 0.2s ease;
}

.BankVerification_uploadBox__A5u\\+q:hover {
  border-color: #8b5cf6; /* subtle fintech accent */
  background: #faf9ff;
}

.BankVerification_uploadIcon__YSke2 {
  color: #9aa1ad;
  margin-bottom: 0px !important;
}

.BankVerification_uploadText__OS8gR {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 0px !important;
}

.BankVerification_uploadHint__Zac68 {
  font-size: 12px;
  color: #777;
}

.BankVerification_fileInput__0ern1 {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.BankVerification_closeButton__T8o3h {
  position: absolute;
  top: 12px;
  right: 12px;
  background: transparent;
  border: none;
  cursor: pointer;
}

.BankVerification_popup__O2fhG {
  position: relative;
}

.BankVerification_attachedProofContainer__z5Vjj {
  margin-top: 15px;
  padding: 14px 16px;
  background-color: #fcfdfe;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.BankVerification_attachedProofHeader__97T3H {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.BankVerification_attachedProofTitle__RoEgx {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
}

.BankVerification_attachedProofIcon__BHlDt {
  color: #f73439;
}

.BankVerification_attachedProofBadge__LMiGK {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 6px;
  background: #fef3c7;
  color: #b45309;
}

.BankVerification_attachedProofBadgeVerified__deGRu {
  background: #dcfce7;
  color: #15803d;
}

.BankVerification_attachedProofBody__73FYT {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.BankVerification_attachedProofName__vAt8i {
  font-size: 13px;
  color: #475569;
  word-break: break-all;
  max-width: 60%;
}

.BankVerification_attachedProofActions__ONXcT {
  display: flex;
  align-items: center;
  gap: 10px;
}

.BankVerification_viewDocLink__XZux0 {
  font-size: 13px;
  font-weight: 500;
  color: #2563eb;
  text-decoration: underline;
  cursor: pointer;
}

.BankVerification_viewDocLink__XZux0:hover {
  color: #1d4ed8;
}

.BankVerification_changeDocBtn__nvSAj {
  font-size: 12px;
  font-weight: 500;
  padding: 5px 10px;
  border-radius: 6px;
  background-color: #f1f5f9;
  border: 1px solid #cbd5e1;
  color: #334155;
  cursor: pointer;
  transition: all 0.2s ease;
}

.BankVerification_changeDocBtn__nvSAj:hover {
  background-color: #e2e8f0;
}

.BankVerification_bankInfoCard__MchJt {
  margin-top: 12px;
  padding: 10px 14px;
  background-color: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.BankVerification_bankInfoItem__AiV\\+w {
  font-size: 13px;
  color: #334155;
}

.BankVerification_bankInfoLabel__Bzs52 {
  font-weight: 600;
  color: #64748b;
  margin-right: 6px;
}

.BankVerification_bankInfoValue__MgyF- {
  font-weight: 500;
  color: #1e293b;
}
`, "",{"version":3,"sources":["webpack://./src/components/organism/BankVerification.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EAC/B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;EAClC,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,kCAAkC;EAClC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,wEAAwE;EACxE,mCAAmC;EACnC,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,wDAAwD;EACxD,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,wEAAwE;EACxE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,6EAAqD;AACvD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;;IAGE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,cAAc;EACd,kCAAkC;EAClC,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,WAAW;EACX,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,iBAAiB;EACjB,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,8DAAsC;AACxC;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,6EAAqD;AACvD;;AAEA;EACE;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;;EAEE,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,0CAA0C;EAC1C,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;;EAEE,gCAAgC;EAChC,kDAAkD;AACpD;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,4BAA4B;EAC5B,2CAA2C;EAC3C,2BAA2B;EAC3B,4DAA4D;EAC5D,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,0FAAkE;AACpE;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,UAAU;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,qEAA6C;AAC/C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kEAA0C;EAC1C,8CAA8C;EAC9C,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+DAAuC;EACvC,mDAAmD;EACnD,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;IACE,mBAAmB;IACnB,0CAA0C;EAC5C;EACA;IACE,sBAAsB;IACtB,0CAA0C;EAC5C;EACA;IACE,mBAAmB;IACnB,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;EACb;;EAEA;IACE,0DAA0D;IAC1D,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;;EAEE,uBAAuB;EACvB,mCAAmC;EACnC,mCAAmC;EACnC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,6DAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;AACA,oBAAoB;AACpB;EACE,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAE,UAAU;EAC9B,WAAW;AACb;;AAEA,aAAa;AACb;EACE,eAAe;EACf,WAAW;EACX,mBAAmB,EAAE,WAAW;EAChC,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB,EAAE,YAAY;EAChC,mBAAmB,EAAE,oBAAoB;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAE,YAAY;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB,EAAE,mBAAmB;EACvC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB,EAAE,mBAAmB;AAC1C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;;EAEjC,oCAAoC;EACpC,2BAA2B;;EAE3B,sBAAsB;EACtB,0BAA0B;;EAE1B,WAAW;EACX,gBAAgB;EAChB,UAAU;;EAEV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;;wBAEsB;AACxB;;AAEA;EACE,qBAAqB,EAAE,0BAA0B;EACjD,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".MainContainer {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  padding: clamp(20px, 5vw, 50px);\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.MainWrapper {\n  border: 1px solid #ffaeae;\n  border-radius: 20px;\n  background-color: #fff;\n  box-shadow: 0 0 15px 3px #817e7e1a;\n  width: 90%;\n  max-width: 800px;\n  height: 100%;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n.topPANDiv {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border-bottom: 1px solid #e4e4e4;\n  padding: 12px;\n}\n\n.topPanText {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 28px;\n  color: #363636;\n  margin-top: 5px;\n}\n\n.topClockDiv {\n  display: flex;\n  gap: 5px;\n  margin-top: 7px;\n}\n\n.clockIcon {\n  height: 20px;\n  width: 20px;\n  align-self: center;\n}\n\n.clockText {\n  font-size: 14px;\n  color: #817e7e;\n}\n\n.panDemoDiv {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  margin-top: 30px;\n}\n\n.EnterYourPan {\n  font-family: \"CircularXXWeb-Medium\";\n  font-size: 16px;\n  color: #040404cc;\n}\n\n.panInputDiv {\n  display: flex;\n  flex-direction: column;\n  padding: 0 clamp(15px, 5vw, 25%);\n  margin-top: clamp(30px, 5vh, 50px);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.shieldDiv {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin: 0 auto;\n  justify-content: center;\n  margin-top: 50px;\n}\n\n.shieldText {\n  font-size: 14px;\n  color: #404040bf;\n  margin-left: 5px;\n}\n\n.Line {\n  border-bottom: 1px solid #e4e4e4;\n  margin-top: 50px;\n}\n\n.verifyButton {\n  background-image: linear-gradient(to right, #f73439, #f8777b) !important;\n  font-size: clamp(14px, 1.5vw, 16px);\n  font-weight: 500;\n  font-stretch: normal;\n  color: #fff;\n  border-radius: 10px !important;\n  border: none;\n  cursor: pointer;\n  padding: clamp(10px, 1.5vw, 14px) clamp(24px, 3vw, 34px);\n  margin: clamp(15px, 2vh, 20px) auto;\n  width: fit-content;\n  min-width: 140px;\n  text-align: center;\n  box-shadow: 0 4px 15px rgba(247, 52, 57, 0.2);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.verifyButton:active {\n  box-shadow: 0 3px 10px rgba(247, 52, 57, 0.2);\n}\n\n.verifyButton:disabled {\n  background-image: linear-gradient(to right, #cccccc, #dddddd) !important;\n  cursor: not-allowed;\n  box-shadow: none;\n  opacity: 0.8;\n}\n\n.verifyButton.loading {\n  pointer-events: none;\n}\n\n.loadingDots {\n  display: inline-flex;\n  margin-left: 8px;\n  align-items: center;\n}\n\n.loadingDots span {\n  width: 4px;\n  height: 4px;\n  margin: 0 2px;\n  background-color: #fff;\n  border-radius: 50%;\n  display: inline-block;\n  animation: loadingDots 1.4s infinite ease-in-out both;\n}\n\n.loadingDots span:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.loadingDots span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.loadingDots span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes loadingDots {\n  0%,\n  80%,\n  100% {\n    transform: scale(0);\n    opacity: 0.5;\n  }\n  40% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.PaymentDiv {\n  display: flex;\n  width: clamp(85%, 75%, 95%);\n  margin: 0 auto;\n  margin-top: clamp(30px, 5vh, 50px);\n  justify-content: space-between;\n  border: 1px solid #e8e8e8;\n  border-radius: 16px;\n  padding: clamp(18px, 2.5vw, 26px);\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 20px;\n  background: #fff;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.PaymentDiv:hover {\n  border-color: #f73439;\n  background: #fff;\n  box-shadow: 0 8px 20px rgba(247, 52, 57, 0.1);\n  transform: translateY(-2px);\n}\n\n.UPI_Container {\n  display: flex;\n}\n\n@keyframes shine {\n  to {\n    background-position: -100% 0;\n  }\n}\n\n.PaymentMode {\n  width: 100%;\n  flex: 1;\n  min-width: 200px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.PaymentHeading {\n  display: flex;\n  font-size: clamp(14px, 2vw, 16px);\n  margin-top: 0.5px;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  color: #2d2d2d;\n  font-weight: 500;\n  text-align: left;\n}\n\n.UPI_Layer {\n  margin-left: 5px;\n  color: #f73439;\n  font-weight: 600;\n  max-height: 25px;\n}\n\n.PaymentDes {\n  font-size: 13px;\n  color: #666;\n  white-space: break-spaces;\n  margin-top: 12px;\n  line-height: 1.6;\n  letter-spacing: 0.2px;\n  width: 250px;\n}\n\n.PaymentDesBank {\n  margin-left: 10%;\n  margin-top: 10px;\n}\n\n.customCheckbox {\n  display: flex;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  align-items: flex-start;\n}\n\n.customCheckbox:hover {\n  transform: translateY(-1px);\n}\n\n.customCheckbox input {\n  display: none;\n}\n\n.customCheckbox .checkmark {\n  width: 22px;\n  height: 22px;\n  border: 2px solid #f73439;\n  border-radius: 6px;\n  margin-right: 12px;\n  position: relative;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 6px rgba(247, 52, 57, 0.1);\n}\n\n.customCheckbox:hover .checkmark {\n  box-shadow: 0 4px 8px rgba(247, 52, 57, 0.15);\n}\n\n.customCheckbox input:checked + .checkmark {\n  background-color: #f73439;\n  animation: checkmark-pop 0.3s ease-out;\n}\n\n@keyframes checkmark-pop {\n  0% {\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.customCheckbox input:checked + .checkmark::after {\n  content: \"\";\n  position: absolute;\n  left: 6px;\n  top: 2px;\n  width: 6px;\n  height: 12px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n  animation: checkmark-check 0.2s ease-in-out 0.1s both;\n}\n\n@keyframes checkmark-check {\n  0% {\n    height: 0;\n    opacity: 0;\n  }\n  100% {\n    height: 12px;\n    opacity: 1;\n  }\n}\n\n.bankInput1,\n.bankInput2 {\n  border: none;\n  border-bottom: 2px solid #fa7a70;\n  border-top: none;\n  padding: 10px 8px;\n  font-size: 15px;\n  width: 100%;\n  transition: all 0.3s ease;\n  background-color: rgba(255, 255, 255, 0.7);\n  color: #333;\n  margin-bottom: 15px;\n  outline: none;\n  position: relative;\n  z-index: 10;\n  cursor: text;\n  border-radius: 4px 4px 0 0;\n}\n\n.bankInput1:focus,\n.bankInput2:focus {\n  border-bottom: 2px solid #f73439;\n  box-shadow: 0 4px 6px -4px rgba(247, 52, 57, 0.25);\n}\n\n.bankInput1::placeholder,\n.bankInput2::placeholder {\n  color: #999;\n  font-size: 14px;\n}\n\n.upiBottomSheet {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #fff;\n  border-radius: 20px 20px 0 0;\n  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);\n  transform: translateY(100%);\n  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n  z-index: 1000;\n  padding: 24px;\n  max-height: 85vh;\n  overflow-y: auto;\n  backdrop-filter: blur(10px);\n}\n\n.upiBottomSheet.show {\n  transform: translateY(0);\n  animation: slideUpAnimation 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@keyframes slideUpAnimation {\n  from {\n    transform: translateY(100%);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n\n.upiBottomSheetOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s ease;\n  z-index: 999;\n  backdrop-filter: blur(3px);\n}\n\n.upiBottomSheetOverlay.show {\n  opacity: 1;\n  visibility: visible;\n  animation: fadeInAnimation 0.3s ease forwards;\n}\n\n@keyframes fadeInAnimation {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.bottomSheetHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  position: sticky;\n  top: 0;\n  background: #fff;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.bottomSheetTitle {\n  font-size: 16px;\n  font-weight: 500;\n  color: #333;\n}\n\n.closeButton {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: none;\n  background: #f5f5f5;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  font-size: 18px;\n  color: #555;\n}\n\n.closeButton:hover {\n  background: #ebebeb;\n  transform: rotate(90deg);\n}\n\n.closeButton:active {\n  transform: scale(0.92) rotate(90deg);\n  background: #e0e0e0;\n}\n\n.timerSection {\n  text-align: center;\n  margin-bottom: 16px;\n  padding: 12px 0;\n}\n\n.timerCircle {\n  width: 90px;\n  height: 90px;\n  border-radius: 50%;\n  border: 3px solid #f73439;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  font-weight: bold;\n  color: #f73439;\n  margin: 0 auto 16px;\n  animation: pulse 1.5s ease-in-out infinite;\n  box-shadow: 0 6px 20px rgba(247, 52, 57, 0.15);\n  background: rgba(255, 255, 255, 0.9);\n}\n\n.timerText {\n  color: #555;\n  font-size: 14px;\n  margin-top: 10px;\n  line-height: 1.5;\n  font-weight: 500;\n  max-width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.timer {\n  margin: 24px 0;\n  position: relative;\n}\n\n.timerPopup {\n  max-width: 360px;\n}\n\n.upiAppsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(55px, 1fr));\n  gap: 8px;\n  margin-top: 16px;\n  padding: 0 4px;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(15px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.upiBottomSheet.show .upiAppIcon {\n  animation: fadeInUp 0.25s ease forwards;\n  animation-delay: calc(0.04s * var(--icon-index, 0));\n  opacity: 0;\n}\n\n.upiAppIcon {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 3px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  padding: 5px;\n  border-radius: 6px;\n  margin: 3px;\n  height: 50px;\n}\n\n.upiAppIcon:active {\n  background-color: rgba(247, 52, 57, 0.05);\n  transform: scale(0.95);\n}\n\n.upiAppIcon img {\n  width: 24px;\n  height: 24px;\n  padding: 3px;\n  border-radius: 6px;\n  background: #f8f8f8;\n  transition: all 0.2s ease;\n  object-fit: contain;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.upiAppIcon:hover {\n  transform: translateY(-2px);\n}\n\n.upiAppIcon:hover img {\n  background: #f0f0f0;\n}\n\n.upiAppLabel {\n  font-size: 11px;\n  color: #555;\n  margin-top: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  font-weight: 500;\n  letter-spacing: 0.2px;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 rgba(247, 52, 57, 0.4);\n  }\n  70% {\n    transform: scale(1.03);\n    box-shadow: 0 0 0 8px rgba(247, 52, 57, 0);\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 rgba(247, 52, 57, 0);\n  }\n}\n\n@media (max-width: 768px) {\n  .popupContentDesktop {\n    display: none;\n  }\n\n  .popupContentMobile {\n    display: block;\n    padding: 15px 10px;\n  }\n\n  .timerCircle {\n    width: 70px;\n    height: 70px;\n    font-size: 18px;\n    border-width: 2px;\n    margin-bottom: 12px;\n  }\n\n  .upiBottomSheet {\n    padding: 20px 16px;\n    border-radius: 20px 20px 0 0;\n  }\n\n  .bottomSheetHeader {\n    margin-bottom: 12px;\n    padding-bottom: 10px;\n  }\n\n  .bottomSheetTitle {\n    font-size: 16px;\n    font-weight: 600;\n  }\n\n  .closeButton {\n    width: 28px;\n    height: 28px;\n    top: 12px;\n    right: 12px;\n  }\n\n  .upiAppsGrid {\n    grid-template-columns: repeat(auto-fit, minmax(60px, 1fr));\n    gap: 12px;\n    margin-top: 20px;\n  }\n\n  .upiAppIcon {\n    width: 42px;\n    height: 42px;\n    padding: 8px;\n  }\n\n  .upiAppLabel {\n    font-size: 12px;\n    letter-spacing: 0.1px;\n    margin-top: 6px;\n  }\n\n  .timerSection {\n    margin-bottom: 15px;\n    padding: 10px 0;\n  }\n\n  .timerText {\n    font-size: 13px;\n    max-width: 90%;\n  }\n\n  .upiAppButtons {\n    gap: 14px;\n    margin: 16px 0;\n  }\n\n  .popup {\n    padding: 20px 16px;\n    max-width: 340px;\n  }\n\n  .popupContent h3 {\n    font-size: 18px;\n    margin-bottom: 12px;\n  }\n\n  .popupContent h4 {\n    font-size: 16px;\n    margin: 12px 0;\n  }\n\n  .popupContent p {\n    font-size: 13px;\n    margin-bottom: 16px;\n  }\n\n  .popupContent button {\n    padding: 9px 20px;\n    font-size: 14px;\n  }\n}\n\n@media (min-width: 769px) {\n  .popupContentMobile {\n    display: none;\n  }\n\n  .popupContentDesktop {\n    display: block;\n  }\n}\n\n.BankLabel1,\n.BankLabel2 {\n  color: rgb(0 0 0 / 87%);\n  font-size: clamp(10px, 1.2vw, 12px);\n  margin-bottom: clamp(5px, 1vh, 7px);\n  position: relative;\n  z-index: 5;\n}\n\n.BankLabel1 {\n  margin-top: clamp(30px, 5vh, 50px);\n}\n.Bankifsc {\n  margin-top: 10%;\n}\n\n.errorText {\n  color: #f73439;\n  font-size: 12px;\n  margin-top: -10px;\n  margin-bottom: 10px;\n  font-weight: 500;\n  background-color: rgba(247, 52, 57, 0.05);\n  padding: 6px 8px;\n  border-radius: 4px;\n  position: relative;\n  z-index: 10;\n}\n\n.popupOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.popup {\n  background: white;\n  padding: clamp(20px, 3vw, 28px);\n  border-radius: 16px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n  max-width: 420px;\n  width: 95%;\n  margin: 10px;\n  box-sizing: border-box;\n  animation: popupFadeIn 0.3s ease-out;\n  transform-origin: center;\n}\n\n@keyframes popupFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.popupContent {\n  text-align: center;\n}\n\n.popupContent h3 {\n  color: #333;\n  margin-bottom: 16px;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.popupContent h4 {\n  color: #f73439;\n  margin: 16px 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.popupContent p {\n  color: #555;\n  margin-bottom: 20px;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.popupContent button {\n  background-image: linear-gradient(to right, #f73439, #f8777b);\n  color: white;\n  border: none;\n  padding: 10px 24px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 10px rgba(247, 52, 57, 0.2);\n  margin-top: 8px;\n}\n\n.popupContent button:hover {\n  background-image: linear-gradient(to right, #e62d32, #f66b6f);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 15px rgba(247, 52, 57, 0.25);\n}\n\n.popupContent button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(247, 52, 57, 0.2);\n}\n\n.upiImgPopupWrapper {\n  display: flex;\n  gap: 18px;\n  align-items: center;\n  width: 100%;\n  justify-content: center;\n  margin: 20px 0;\n}\n\n.upiImgPopup {\n  height: 32px;\n  transition: all 0.2s ease;\n  padding: 8px;\n  border-radius: 12px;\n  background-color: #f8f8f8;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.upiImgPopup:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  background-color: #f0f0f0;\n}\n\n.upiAppButtons {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  margin: 20px 0;\n  flex-wrap: wrap;\n}\n\n.upiAppIcon {\n  width: 48px;\n  height: 48px;\n  padding: 10px;\n  border-radius: 12px;\n  background-color: #f8f8f8;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.upiAppIcon:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  background-color: #f0f0f0;\n}\n\n.popupContentDesktop {\n  text-align: center;\n  padding: 5px;\n}\n\n.popupContentDesktop img[alt=\"UPI_QR\"] {\n  max-width: 200px;\n  height: auto;\n  margin: 15px auto;\n  border-radius: 12px;\n  padding: 12px;\n  background-color: white;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n}\n\n.popupContentDesktop img[alt=\"UPI_QR\"]:hover {\n  transform: scale(1.02);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);\n}\n\n.popupContentMobile {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .MainWrapper {\n    width: 95%;\n    margin: 10px;\n  }\n\n  .PaymentDiv {\n    width: 90%;\n    padding: 12px;\n  }\n\n  .PaymentMode {\n    width: 100%;\n  }\n\n  .PaymentDes {\n    font-size: 11px;\n  }\n\n  .topPanText {\n    font-size: clamp(16px, 4vw, 20px);\n  }\n\n  .clockText {\n    font-size: 12px;\n  }\n\n  .popupContentDesktop {\n    display: none;\n  }\n\n  .popupContentMobile {\n    display: block;\n    padding: 10px;\n  }\n\n  .upiImgPopup {\n    height: 25px;\n  }\n\n  .popup {\n    margin: 5px;\n    padding: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .MainContainer {\n    padding: 10px;\n  }\n\n  .MainWrapper {\n    width: 100%;\n    margin: 0;\n    border-radius: 10px;\n  }\n\n  .PaymentDiv {\n    width: 95%;\n    padding: 10px;\n    margin-top: 20px;\n  }\n\n  .shieldDiv {\n    margin-top: 30px;\n    padding: 0 10px;\n  }\n\n  .shieldText {\n    font-size: 12px;\n  }\n\n  .Line {\n    margin-top: 30px;\n  }\n}\n/* Popup container */\n.popupContent {\n  padding: 22px 24px 24px;\n}\n\n/* Title */\n.popupTitle {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 6px; /* was 8 */\n  color: #111;\n}\n\n/* Subtitle */\n.popupSubText {\n  font-size: 14px;\n  color: #555;\n  margin-bottom: 18px; /* was 16 */\n  line-height: 1.45;\n}\n\n/* Document box */\n.documentBox {\n  background: #f6f7f9;\n  border-radius: 8px;\n  padding: 12px 14px; /* tighter */\n  margin-bottom: 20px; /* more separation */\n}\n\n.documentTitle {\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 4px; /* tighter */\n}\n\n.documentBox ul {\n  margin: 0;\n  padding-left: 16px; /* tighter indent */\n  font-size: 13px;\n  color: #444;\n}\n\n.documentBox li {\n  margin-bottom: 4px;\n}\n\n/* Upload field */\n.uploadField {\n  margin-bottom: 22px; /* more breathing */\n}\n\n.uploadLabel {\n  display: block;\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 6px;\n  color: #333;\n}\n\n.fileInput {\n  width: 100%;\n  font-size: 13px;\n  padding: 6px 2px;\n}\n\n.uploadHint {\n  font-size: 12px;\n  color: #777;\n  margin-top: 6px;\n}\n\n/* Buttons */\n.popupPrimaryBtn {\n  width: 100%;\n  height: 44px;\n  margin-top: 4px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.popupSecondaryBtn {\n  background: transparent !important;\n  background-image: none !important;\n\n  border: 1px solid #f85e63 !important;\n  box-shadow: none !important;\n\n  color: #666 !important;\n  font-size: 13px !important;\n\n  width: 100%;\n  margin-top: 14px;\n  padding: 0;\n\n  cursor: pointer;\n}\n\n.fileInput {\n  width: 100%;\n  font-size: 13px;\n}\n\n.uploadHint {\n  font-size: 12px !important;\n  color: #777;\n  margin-top: 4px;\n}\n\n.uploadField {\n  margin-bottom: 20px;\n}\n\n.uploadLabel {\n  display: block;\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 6px;\n  color: #333;\n}\n\n.uploadBox {\n  position: relative;\n  border: 2px dashed #cfd4dc;\n  border-radius: 12px;\n  padding: 28px 16px;\n  text-align: center;\n  background: #fff;\n  cursor: pointer;\n  transition:\n    border-color 0.2s ease,\n    background 0.2s ease;\n}\n\n.uploadBox:hover {\n  border-color: #8b5cf6; /* subtle fintech accent */\n  background: #faf9ff;\n}\n\n.uploadIcon {\n  color: #9aa1ad;\n  margin-bottom: 0px !important;\n}\n\n.uploadText {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 0px !important;\n}\n\n.uploadHint {\n  font-size: 12px;\n  color: #777;\n}\n\n.fileInput {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.closeButton {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n.popup {\n  position: relative;\n}\n\n.attachedProofContainer {\n  margin-top: 15px;\n  padding: 14px 16px;\n  background-color: #fcfdfe;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.attachedProofHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.attachedProofTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #334155;\n}\n\n.attachedProofIcon {\n  color: #f73439;\n}\n\n.attachedProofBadge {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 6px;\n  background: #fef3c7;\n  color: #b45309;\n}\n\n.attachedProofBadgeVerified {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.attachedProofBody {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.attachedProofName {\n  font-size: 13px;\n  color: #475569;\n  word-break: break-all;\n  max-width: 60%;\n}\n\n.attachedProofActions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.viewDocLink {\n  font-size: 13px;\n  font-weight: 500;\n  color: #2563eb;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.viewDocLink:hover {\n  color: #1d4ed8;\n}\n\n.changeDocBtn {\n  font-size: 12px;\n  font-weight: 500;\n  padding: 5px 10px;\n  border-radius: 6px;\n  background-color: #f1f5f9;\n  border: 1px solid #cbd5e1;\n  color: #334155;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.changeDocBtn:hover {\n  background-color: #e2e8f0;\n}\n\n.bankInfoCard {\n  margin-top: 12px;\n  padding: 10px 14px;\n  background-color: #f8fafc;\n  border: 1px dashed #cbd5e1;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.bankInfoItem {\n  font-size: 13px;\n  color: #334155;\n}\n\n.bankInfoLabel {\n  font-weight: 600;\n  color: #64748b;\n  margin-right: 6px;\n}\n\n.bankInfoValue {\n  font-weight: 500;\n  color: #1e293b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MainContainer": `BankVerification_MainContainer__xPJpj`,
	"MainWrapper": `BankVerification_MainWrapper__ft++V`,
	"topPANDiv": `BankVerification_topPANDiv__IePNZ`,
	"topPanText": `BankVerification_topPanText__2Ax11`,
	"topClockDiv": `BankVerification_topClockDiv__x6gAy`,
	"clockIcon": `BankVerification_clockIcon__UZ195`,
	"clockText": `BankVerification_clockText__o0chU`,
	"panDemoDiv": `BankVerification_panDemoDiv__3uVKi`,
	"EnterYourPan": `BankVerification_EnterYourPan__-RuFW`,
	"panInputDiv": `BankVerification_panInputDiv__lFBL0`,
	"shieldDiv": `BankVerification_shieldDiv__UNQtN`,
	"shieldText": `BankVerification_shieldText__M9D3Q`,
	"Line": `BankVerification_Line__WJKmg`,
	"verifyButton": `BankVerification_verifyButton__mBlu4`,
	"loading": `BankVerification_loading__GJCBH`,
	"loadingDots": `BankVerification_loadingDots__2ylHq`,
	"PaymentDiv": `BankVerification_PaymentDiv__rlRlj`,
	"UPI_Container": `BankVerification_UPI_Container__JHSUu`,
	"PaymentMode": `BankVerification_PaymentMode__EjiHa`,
	"PaymentHeading": `BankVerification_PaymentHeading__8-0d3`,
	"UPI_Layer": `BankVerification_UPI_Layer__p-+wO`,
	"PaymentDes": `BankVerification_PaymentDes__XC8gC`,
	"PaymentDesBank": `BankVerification_PaymentDesBank__rLXRd`,
	"customCheckbox": `BankVerification_customCheckbox__Dh9jK`,
	"checkmark": `BankVerification_checkmark__U6fPL`,
	"checkmark-pop": `BankVerification_checkmark-pop__xBmFe`,
	"checkmark-check": `BankVerification_checkmark-check__FdAnV`,
	"bankInput1": `BankVerification_bankInput1__4Ga8C`,
	"bankInput2": `BankVerification_bankInput2__ZudwV`,
	"upiBottomSheet": `BankVerification_upiBottomSheet__dLcfl`,
	"show": `BankVerification_show__RTxCj`,
	"slideUpAnimation": `BankVerification_slideUpAnimation__hLmJa`,
	"upiBottomSheetOverlay": `BankVerification_upiBottomSheetOverlay__itxd+`,
	"fadeInAnimation": `BankVerification_fadeInAnimation__pLoCC`,
	"bottomSheetHeader": `BankVerification_bottomSheetHeader__3Iehc`,
	"bottomSheetTitle": `BankVerification_bottomSheetTitle__BMiLH`,
	"closeButton": `BankVerification_closeButton__T8o3h`,
	"timerSection": `BankVerification_timerSection__J0qym`,
	"timerCircle": `BankVerification_timerCircle__2+r9+`,
	"pulse": `BankVerification_pulse__SGX5c`,
	"timerText": `BankVerification_timerText__4CHZg`,
	"timer": `BankVerification_timer__G2TpL`,
	"timerPopup": `BankVerification_timerPopup__oXGQw`,
	"upiAppsGrid": `BankVerification_upiAppsGrid__EJRHK`,
	"upiAppIcon": `BankVerification_upiAppIcon__UvykF`,
	"fadeInUp": `BankVerification_fadeInUp__BYlqh`,
	"upiAppLabel": `BankVerification_upiAppLabel__rUedf`,
	"popupContentDesktop": `BankVerification_popupContentDesktop__AVtFv`,
	"popupContentMobile": `BankVerification_popupContentMobile__LrY3V`,
	"upiAppButtons": `BankVerification_upiAppButtons__BJnnH`,
	"popup": `BankVerification_popup__O2fhG`,
	"popupContent": `BankVerification_popupContent__sbIB7`,
	"BankLabel1": `BankVerification_BankLabel1__boNp5`,
	"BankLabel2": `BankVerification_BankLabel2__wpfdK`,
	"Bankifsc": `BankVerification_Bankifsc__gADVp`,
	"errorText": `BankVerification_errorText__-JzQ+`,
	"popupOverlay": `BankVerification_popupOverlay__j0iat`,
	"popupFadeIn": `BankVerification_popupFadeIn__Q4u+6`,
	"upiImgPopupWrapper": `BankVerification_upiImgPopupWrapper__Zr572`,
	"upiImgPopup": `BankVerification_upiImgPopup__ybL5s`,
	"popupTitle": `BankVerification_popupTitle__Pz5jQ`,
	"popupSubText": `BankVerification_popupSubText__lMcnE`,
	"documentBox": `BankVerification_documentBox__cGbGF`,
	"documentTitle": `BankVerification_documentTitle__4Sj35`,
	"uploadField": `BankVerification_uploadField__3tYWI`,
	"uploadLabel": `BankVerification_uploadLabel__OXV0x`,
	"fileInput": `BankVerification_fileInput__0ern1`,
	"uploadHint": `BankVerification_uploadHint__Zac68`,
	"popupPrimaryBtn": `BankVerification_popupPrimaryBtn__jKFhF`,
	"popupSecondaryBtn": `BankVerification_popupSecondaryBtn__d+v4L`,
	"uploadBox": `BankVerification_uploadBox__A5u+q`,
	"uploadIcon": `BankVerification_uploadIcon__YSke2`,
	"uploadText": `BankVerification_uploadText__OS8gR`,
	"attachedProofContainer": `BankVerification_attachedProofContainer__z5Vjj`,
	"attachedProofHeader": `BankVerification_attachedProofHeader__97T3H`,
	"attachedProofTitle": `BankVerification_attachedProofTitle__RoEgx`,
	"attachedProofIcon": `BankVerification_attachedProofIcon__BHlDt`,
	"attachedProofBadge": `BankVerification_attachedProofBadge__LMiGK`,
	"attachedProofBadgeVerified": `BankVerification_attachedProofBadgeVerified__deGRu`,
	"attachedProofBody": `BankVerification_attachedProofBody__73FYT`,
	"attachedProofName": `BankVerification_attachedProofName__vAt8i`,
	"attachedProofActions": `BankVerification_attachedProofActions__ONXcT`,
	"viewDocLink": `BankVerification_viewDocLink__XZux0`,
	"changeDocBtn": `BankVerification_changeDocBtn__nvSAj`,
	"bankInfoCard": `BankVerification_bankInfoCard__MchJt`,
	"bankInfoItem": `BankVerification_bankInfoItem__AiV+w`,
	"bankInfoLabel": `BankVerification_bankInfoLabel__Bzs52`,
	"bankInfoValue": `BankVerification_bankInfoValue__MgyF-`,
	"shine": `BankVerification_shine__lrOXM`
};
export default ___CSS_LOADER_EXPORT___;
